import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const deleteJobFunc = createAsyncThunk("job/delete", async (jobId) => {
  const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
  const request = await fetch(
    `${process.env.REACT_APP_VERSEL_API}/api/users/carrers/delete/${jobId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${tokenData}`,
      },
    }
  )
    .then((respons) => respons.json())
    .then((resulet) => {
      return resulet;
    })
    .catch((e) => {
      return e;
    });

  return request;
});


const deleteJobSlicer = createSlice({
  name: "job/delete",
  initialState: {
    responst: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(deleteJobFunc.fulfilled, (state, action) => {
      if (action.payload.message === "Postion deleted successfully") {
        state.responst = action.payload.message;
      } else {
        state.error = action.payload.message;
      }
    });
    builder.addCase(deleteJobFunc.rejected, (state, action) => {
      state.error = action.payload.message;
    });
  },
});

export default deleteJobSlicer.reducer;
